import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="py-12 md:py-20 px-5 md:px-8 relative overflow-hidden" data-id="element-206">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#15203B] rounded-full blur-[120px] opacity-50 -z-10 pointer-events-none" data-id="element-207"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-209">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-serif" data-id="element-210">
            <span className="text-[#F6C65B]" data-id="element-211">Protocolo Silencio TTPM™</span>:
            La rutina nocturna de 3 minutos que ayuda a calmar la percepción del
            zumbido para dormir con más tranquilidad
          </h1>

          <h2 className="text-lg md:text-2xl text-gray-300 font-medium mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-212">
            Sin pastillas. Sin aparatos costosos. Sin depender de ruido blanco
            toda la noche.
          </h2>

          <p className="text-base md:text-lg text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-213">
            Una guía práctica diseñada para ayudar a tu sistema nervioso a dejar
            de perseguir el sonido justo cuando más necesitas descansar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-2xl mx-auto mb-12" data-id="element-214">
          <div className="absolute inset-0 bg-gradient-to-t from-[#070B16] via-transparent to-transparent z-10 h-full w-full bottom-0" data-id="element-215"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9WRNLVyyLHnvGSLRJ1WJNU/Gemini_Generated_Image_4z6er44z6er44z6e.jpg" alt="Protocolo Silencio TTPM en tablet" className="w-full h-auto rounded-xl shadow-2xl border border-[#15203B]" width="1024" height="1024" fetchPriority="high" decoding="async" loading="eager" data-id="element-216" />
          <div className="absolute bottom-6 left-0 right-0 z-20 text-center px-4" data-id="element-217">
            <p className="text-[#F6C65B] font-bold text-xl drop-shadow-lg" data-id="element-218">
              Protocolo Silencio TTPM™
            </p>
            <p className="text-white text-sm md:text-base drop-shadow-md" data-id="element-219">
              Rutina nocturna para reducir la atención al zumbido y descansar
              mejor
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center justify-center" data-id="element-220">
          <a href="#comprar" className="bg-[#F6C65B] hover:bg-[#FFD680] text-[#070B16] font-bold text-lg md:text-xl px-8 py-4 rounded-lg transition-all duration-300 shadow-[0_0_25px_rgba(246,198,91,0.4)] transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto min-w-[280px]" data-id="element-221">
            Quiero probar el protocolo
          </a>
          <p className="text-gray-400 text-sm mt-3" data-id="element-222">
            Acceso inmediato · Método guiado · Precio especial hoy
          </p>
        </motion.div>
      </div>
    </section>;
}